
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.331 4.582L12 11v4.002h3.991l6.428-6.324-4.088-4.096zM14 11.821l4.34-4.4 1.24 1.244-4.408 4.337H14V11.82z"}}),_c('path',{attrs:{"d":"M4 5.002h10v2H6v8H4v-10zM22 19.002H2v-2h20v2z"}})])
          )
        }
      }
    